import { useState } from 'react'
import Modal from '@components/modal'
import Column from '@components/column'
import { Formik, Form } from 'formik'
import Fields from '@components/fields'
import { AppointmentSchema } from '@validations'
import { Appointment } from '@apis'
import Row from '@components/row'
import Button from '@components/button'
const AppointmentCancel = ({ visible, id, onClose }: any) => {
  const [loading, setLoading] = useState<boolean>(false)
  const cancelledSubmitHandler = async (values) => {
    setLoading(true)
    await Appointment.updateStatus({
      data: {
        reason: values?.reason,
        status: values?.status,
      },
      id: id,
      state: 'consultAppointment',
    })
      .then(() => {
        onClose?.()
      })
      .catch(() => {})
    setLoading(false)
  }
  return (
    <>
      {!!visible && (
        <Modal
          visible={visible}
          onClose={onClose}
          title="Do you want to Cancel Appointment"
        >
          <Formik
            initialValues={{
              reason: '',
              status: 'Cancelled',
            }}
            onSubmit={cancelledSubmitHandler}
            enableReinitialize
            validationSchema={AppointmentSchema.cancelValidationSchema}
          >
            {({ handleSubmit }) => {
              return (
                <Form onSubmit={handleSubmit}>
                  <Column rowGap={20}>
                    <Fields.TextArea
                      name="reason"
                      label="Reason"
                      placeholder="Reason..."
                      rows={3}
                    />
                    <Row justifyContent="space-between">
                      <Button
                        title="Close"
                        outline
                        bg="danger"
                        styleButton="width:100%"
                        styleButtonWrapper="width:49%"
                        height={40}
                        onClick={onClose}
                      />
                      <Button
                        type="submit"
                        title="Submit"
                        styleButton="width:100%"
                        styleButtonWrapper="width:49%"
                        height={40}
                        loading={loading}
                      />
                    </Row>
                  </Column>
                </Form>
              )
            }}
          </Formik>
        </Modal>
      )}
    </>
  )
}

export default AppointmentCancel
